import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';

export default observer(function StaticTable({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        overflow: 'auto',
        height: 1,
        maxHeight: { mobile: '50vh', laptop: 'unset' },

        table: {
          'display': 'table',
          'borderCollapse': 'collapse',
          'width': 1,
          'tr': {
            verticalAlign: 'top',
          },
          'tr:first-of-type': {
            bgcolor: 'transparent !important',
          },
          'tr:nth-of-type(odd)': {
            bgcolor: 'custom.tableOdd',
          },
          'th': {
            textAlign: 'start',
          },
          'td': {
            width: '33%',
            border: 0,
          },
          'td:not(:first-of-type)': {
            borderLeft: 1,
            borderColor: 'custom.lightGrey',
          },
        },
      }}
    >
      <table>
        <tbody>{children}</tbody>
      </table>
    </Box>
  );
});
